import * as Yup from 'yup';

const telRegExp = /^\(\d{2}\) \d{4}-\d{4}|\(\d{2}\) \d{5}-\d{4}$/
const emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const TicketRegistrationValidation = Yup.object().shape({
    tel: Yup.string().matches(telRegExp, 'Insira um telefone válido').required('O telefone é obrigatório'),
    email1: Yup.string().matches(emailRegExp,'Insira um e-mail válido'),
    email2: Yup.string().matches(emailRegExp,'Insira um e-mail válido'),
    email3: Yup.string().matches(emailRegExp,'Insira um e-mail válido'),
})
